import { render, staticRenderFns } from "./CampaignTypeComponent.vue?vue&type=template&id=2241d0b1"
import script from "./CampaignTypeComponent.vue?vue&type=script&lang=js"
export * from "./CampaignTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports